module.exports = __webpack_public_path__ + "static/img/gswkwx.cb830e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gswkwx.png
// module id = bPIp
// module chunks = 0